import ReactDOM from "react-dom/client";
import { useRef } from "react";
import { Exit } from "../../Common/js/OS.1.0.4.0.js";
import bgImage from "../images/BG.png";
import "../css/tw-styles.css";

function App() {
  const hasExited = useRef(false);

  function handleExit() {
    if (hasExited.current) return;
    hasExited.current = true;
    Exit();
  }

  return (
    <div
      className="w-screen h-screen overflow-hidden flex items-center justify-center"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center"
      }}
    >
      <div className="w-full px-8 md:px-16 lg:px-24 xl:px-32 2xl:px-40 flex flex-col items-center lg:items-start text-center lg:text-left">
        <div>
          <h1 className="text-white text-5xl md:text-7xl lg:text-[90px] xl:text-[120px] 2xl:text-[150px] font-black leading-[0.9] tracking-tight uppercase font-delta">
            IT'S YOUR
            <br />
            TIME TO
          </h1>

          <h1 className="text-white text-5xl md:text-7xl lg:text-[90px] xl:text-[120px] 2xl:text-[150px] font-black leading-[0.9] tracking-tight uppercase font-delta">
            COMMIT
            <br />
            TO SAFETY.
          </h1>
        </div>

        <button
          onClick={handleExit}
          className="mt-8 lg:mt-10 border border-white lg:border-2 text-white text-sm lg:text-lg xl:text-xl font-bold tracking-widest uppercase rounded-full px-6 py-2 lg:px-8 lg:py-3 xl:px-10 xl:py-4 flex items-center gap-2 lg:gap-3 xl:gap-4 hover:bg-white hover:text-red-700 transition-colors font-whitney-cond"
        >
          START
          <svg
            className="w-4 h-4 lg:w-5 lg:h-5 xl:w-6 xl:h-6"
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <polyline points="2,8 6,12 14,4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  );
}

ReactDOM.createRoot(document.querySelector("#app")).render(<App />);
